import service from "./service";

export const findAllIn = listQuery => {
  return service.get("/v1/receiptBill/in", listQuery);
};
export const findAllOut = listQuery => {
  return service.get("/v1/receiptBill/out", listQuery);
};

export const findAllOutWithCode = listQuery => {
  return service.get("/v1/receiptBill//out/code", listQuery);
};

export const findOne = id => {
  return service.get(`/v1/receiptBill/${id}`);
};

export const update = (id, data) => {
  return service.post(`/v1/receiptbill/${id}`, data);
};

export const createIn = (receiptBill, receiptBillDetails) => {
  return service.post(`/v1/receiptbill/in`, {
    receiptBill,
    receiptBillDetails
  });
};

export const createOut = (receiptBill, receiptBillDetails, order) => {
  return service.post(`/v1/receiptbill/out`, {
    receiptBill,
    receiptBillDetails,
    order
  });
};

export const createReturn = (receiptBill, receiptBillDetail) => {
  return service.post(`/v1/receiptbill/return`, {
    receiptBill,
    receiptBillDetail
  });
};

export const verifyOut = id => {
  return service.post(`/v1/receiptbill/out/${id}/verify`);
};
export const verifyIn = (tem, quantity) => {
  return service.post(`/v1/receiptbill/in/verify`, { tem, quantity });
};

export const status = (id, status, quantityProduce) => {
  return service.post(`/v1/receiptbill/${id}/status`, {
    status,
    quantityProduce
  });
};

export const report = listQuery => {
  return service.get(`/v1/receiptBill/report`, listQuery);
};

export const addPayment = (payment, receiptBills) => {
  return service.post(`/v1/receiptbill/add-payment`, {
    payment,
    receiptBills
  });
};

export const debt = listQuery => {
  return service.get(`/v1/receiptBill/debt`, listQuery);
};

export const turnover = listQuery => {
  return service.get(`/v1/receiptBill/turnover`, listQuery);
};

export const turnoverUser = listQuery => {
  return service.get(`/v1/receiptBill/turnover-user`, listQuery);
};

export const historyPayment = listQuery => {
  return service.get(`/v1/receiptBill/history-payment`, listQuery);
};
